import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class PermissionService {
  static ENDPOINT = `${BASE}/permission`;

  static async getAll({sort = null} = {}) {
    const params = new URLSearchParams();
    if (sort != null) {
      if (sort.column) params.set('sortBy', sort.column);
      if (sort.direction) params.set('direction', sort.direction);
    }    
    const qs = params.toString();
    return await request({
      url: `${this.ENDPOINT}/` + (qs ? `?${qs}` : ''),
      headers: {'Accept': 'application/json'}
    })
  }

  static async getByRole(id) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      headers: {'Accept': 'application/json'}
    })
  }
}

export default PermissionService;
